module.exports = ".full-width{width:100%}.width75{width:74%}.width50{width:49%}.width25{width:22%}mat-form-field{margin:0px 5px 0px 5px}\n"